import React from 'react';

const ConfettiDecoration: React.FC = () => {
  return (
    <div className="absolute inset-0 pointer-events-none z-0">
      <span className="absolute text-2xl text-yellow-400 animate-bounce" style={{top: '15%', left: '10%', animationDelay: '0s'}}>✦</span>
      <span className="absolute text-2xl text-red-400 animate-bounce" style={{top: '25%', right: '15%', animationDelay: '1s'}}>✧</span>
      <span className="absolute text-2xl text-teal-400 animate-bounce" style={{top: '40%', left: '5%', animationDelay: '2s'}}>◆</span>
      <span className="absolute text-2xl text-yellow-400 animate-bounce" style={{top: '60%', right: '10%', animationDelay: '0.5s'}}>✦</span>
      <span className="absolute text-2xl text-blue-400 animate-bounce" style={{top: '75%', left: '15%', animationDelay: '1.5s'}}>◇</span>
      <span className="absolute text-2xl text-green-400 animate-bounce" style={{top: '85%', right: '20%', animationDelay: '2.5s'}}>✧</span>
    </div>
  );
};

export default ConfettiDecoration;